import axios from "axios";
import APP_CONFIG from "../constants/app";

// Create an Axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: APP_CONFIG.API_BASE_URL, // Your API base URL
  timeout: 5000, // Set a timeout (5 seconds in this case)
  headers: {
    "Content-Type": "multipart/form-data", // Set default content type for JSON
    // Add other default headers if needed
  },
});

// Add request interceptors (optional)
axiosInstance.interceptors.request.use(
  (config) => {
   const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
    
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptors (optional)
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
 (error) => {
    const status = error.response?.status;
    const token = localStorage.getItem("access_token");
    if (status === 401) {
      localStorage.removeItem("access_token");
      window.location.href = "/login";
    }

    // if (status === 403) {
    //   window.location.href = "/unauthorized";
    // }

    return Promise.reject(error);
  }
);

export { axiosInstance };

export default axiosInstance;
